import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { POST } from "../../Services/AxiosService";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataStockRep } from "../../Redux/ReportsData/StockReportDataSlice";
import { fetchDataPKRep } from "../../Redux/ReportsData/PackingChallanReportDataSlice";
import { fetchDataSLRep } from "../../Redux/ReportsData/SaleReportDataSlice";
import { CustomStringify } from "../../Helpers/CustomStringify";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Avatar, Divider, IconButton } from "@mui/material";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Collapse from '@mui/material/Collapse';
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AddIcon from '@mui/icons-material/Add';
import Popover from "@mui/material/Popover";
import { styled } from '@mui/material/styles';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  BarChart,
  Bar,
  Rectangle,
  Legend,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
  Cell,
  CartesianAxis,
  PieChart,
  Pie,
  Sector,
} from "recharts";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { MdInventory } from "react-icons/md";
import { IoFileTrayStackedSharp } from "react-icons/io5";
import { FaFileInvoice } from "react-icons/fa6";
import { FaUndo } from "react-icons/fa";
import { MdLocalShipping } from "react-icons/md";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { RiRefundLine } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { FaBoxOpen } from "react-icons/fa";
import { RiNumbersFill } from "react-icons/ri";
import { MdStraighten } from "react-icons/md";

const Item = styled(Paper)(({ theme, border, bghover }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  padding: "5px",
  textAlign: 'center',
  border: `1px solid ${border}`,
  color: "#000",
  fontSize: "12px",
  minWidth: "10vw",
  maxHeight: "50px",
  cursor: "pointer",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: bghover,
  },
  // ...theme.applyStyles('dark', {
  //   backgroundColor: '#1A2027',
  // }),
}));

const QuickLinkList = [
  {
    name: "Sale Order",
    border: "rgb(250, 90, 125)",
    bghover: "rgb(247, 230, 235)",
    link: "/SaleOrder"
  },
  {
    name: "Sale Bill",
    border: "rgb(255, 148, 122)",
    bghover: "rgb(245, 244, 220)",
    link: "/SaleBill"
  },
  {
    name: "Sale Return",
    border: "rgb(29, 196, 194)",
    bghover: "rgb(202, 237, 236)",
    link: "/SaleReturn"
  },
  {
    name: "Purchase Order",
    border: "rgb(208, 214, 34)",
    bghover: "rgb(246, 247, 220)",
    link: "/PurchaseOrder"
  },
  {
    name: "Purchase",
    border: "rgb(191, 131, 255)",
    bghover: "rgb(234, 223, 245)",
    link: "/PurchaseBill"
  },
  {
    name: "Purchase Return",
    border: "rgb(60, 216, 86)",
    bghover: "rgb(218, 245, 230)",
    link: "/PurchaseReturn"
  },
];

export default function CompanyDashboard() {
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);

  const [DateValue, setDateValue] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );

  const [anchorEl, setAnchorEl] = useState({ quick: null, date: null });

  const handleClick = (event) => {
    let Name = event.target.name
    setAnchorEl((pre) => ({ ...pre, [Name]: pre[Name] ? null : event.currentTarget }));
  };

  const handleClose = (Name) => {
    setAnchorEl((pre) => ({ ...pre, [Name]: null }));
  };

  const openQuickLink = Boolean(anchorEl?.quick);
  const openCalender = Boolean(anchorEl?.date);

  // const { cmpdetail } = useSelector((state) => state.CompanyDetail);

  const Theme = useSelector((state) => state.Theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const StockReportData = useSelector((state) => state.StockReportData);
  const PackingChallanReportData = useSelector((state) => state.PackingChallanReportData);
  const SaleReportData = useSelector((state) => state.SaleReportData);

  let StockReport = StockReportData?.result?.data?.map((item) => {
    return {
      ...item,
      Opening:
        item?.Sd_VNature == "OPENING"
          ? Number(item?.Sd_Qty)
          : 0,
      Inward:
        item?.Sd_VNature == "InWord"
          ? Number(item?.Sd_Qty)
          : 0,
      Outward:
        item?.Sd_VNature == "OutWord"
          ? Number(item?.Sd_Qty)
          : 0,
    };
  });
  StockReport = StockReport?.map((item) => {
    return {
      ...item,
      Balance:
        Number(item?.Opening) + Number(item?.Inward) - Number(item?.Outward),
    };
  });

  const PackingChallanReport = PackingChallanReportData?.result?.data;
  const SaleReport = SaleReportData?.result?.data;

  var AprSaleBillReport = [];
  var MaySaleBillReport = [];
  var JuneSaleBillReport = [];
  var JulySaleBillReport = [];
  var AugSaleBillReport = [];
  var SepSaleBillReport = [];
  var OctSaleBillReport = [];
  var NovSaleBillReport = [];
  var DecSaleBillReport = [];
  var JanSaleBillReport = [];
  var FebSaleBillReport = [];
  var MarchSaleBillReport = [];

  PackingChallanReport?.map((item) => {
    if (new Date(item?.Sale_Date).getMonth() == 3) {
      AprSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 4) {
      MaySaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 5) {
      JuneSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 6) {
      JulySaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 7) {
      AugSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 8) {
      SepSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 9) {
      OctSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 10) {
      NovSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 11) {
      DecSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 0) {
      JanSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 1) {
      FebSaleBillReport.push(item);
    } else if (new Date(item?.Sale_Date).getMonth() == 2) {
      MarchSaleBillReport.push(item);
    }
  });

  var AprSaleReturnReport = [];
  var MaySaleReturnReport = [];
  var JuneSaleReturnReport = [];
  var JulySaleReturnReport = [];
  var AugSaleReturnReport = [];
  var SepSaleReturnReport = [];
  var OctSaleReturnReport = [];
  var NovSaleReturnReport = [];
  var DecSaleReturnReport = [];
  var JanSaleReturnReport = [];
  var FebSaleReturnReport = [];
  var MarchSaleReturnReport = [];

  PackingChallanReport?.map((item) => {
    if (new Date(item?.SR_Date).getMonth() == 3) {
      AprSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 4) {
      MaySaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 5) {
      JuneSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 6) {
      JulySaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 7) {
      AugSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 8) {
      SepSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 9) {
      OctSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 10) {
      NovSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 11) {
      DecSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 0) {
      JanSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 1) {
      FebSaleReturnReport.push(item);
    } else if (new Date(item?.SR_Date).getMonth() == 2) {
      MarchSaleReturnReport.push(item);
    }
  });

  const data = [
    {
      Month: "Apr",
      Sale: AprSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: AprSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "May",
      Sale: MaySaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: MaySaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "June",
      Sale: JuneSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: JuneSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "July",
      Sale: JulySaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: JulySaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Aug",
      Sale: AugSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: AugSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Sep",
      Sale: SepSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: SepSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Oct",
      Sale: OctSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: OctSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Nov",
      Sale: NovSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: NovSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Dec",
      Sale: DecSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: DecSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Jan",
      Sale: JanSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: JanSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Feb",
      Sale: FebSaleBillReport?.reduce((acc, item) => acc + item.SLBDtl_Qty, 0),
      SaleReturnReport: FebSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
    {
      Month: "Mar",
      Sale: MarchSaleBillReport?.reduce(
        (acc, item) => acc + item.SLBDtl_Qty,
        0
      ),
      SaleReturnReport: MarchSaleReturnReport?.reduce(
        (acc, item) => acc + item.SRDtl_Qty,
        0
      ),
    },
  ];

  const data2 = [
    { name: "Group A", value: 150 },
    { name: "Group B", value: 300 },
    { name: "Group C", value: 200 },
    { name: "Group D", value: 400 },
  ];

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

  var AprPurchaseBillReport = [];
  var MayPurchaseBillReport = [];
  var JunePurchaseBillReport = [];
  var JulyPurchaseBillReport = [];
  var AugPurchaseBillReport = [];
  var SepPurchaseBillReport = [];
  var OctPurchaseBillReport = [];
  var NovPurchaseBillReport = [];
  var DecPurchaseBillReport = [];
  var JanPurchaseBillReport = [];
  var FebPurchaseBillReport = [];
  var MarchPurchaseBillReport = [];

  PackingChallanReport?.map((item) => {
    if (new Date(item?.P_Main_PUDate).getMonth() == 3) {
      AprPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 4) {
      MayPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 5) {
      JunePurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 6) {
      JulyPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 7) {
      AugPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 8) {
      SepPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 9) {
      OctPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 10) {
      NovPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 11) {
      DecPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 0) {
      JanPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 1) {
      FebPurchaseBillReport.push(item);
    } else if (new Date(item?.P_Main_PUDate).getMonth() == 2) {
      MarchPurchaseBillReport.push(item);
    }
  });

  var AprPurchaseReturnReport = [];
  var MayPurchaseReturnReport = [];
  var JunePurchaseReturnReport = [];
  var JulyPurchaseReturnReport = [];
  var AugPurchaseReturnReport = [];
  var SepPurchaseReturnReport = [];
  var OctPurchaseReturnReport = [];
  var NovPurchaseReturnReport = [];
  var DecPurchaseReturnReport = [];
  var JanPurchaseReturnReport = [];
  var FebPurchaseReturnReport = [];
  var MarchPurchaseReturnReport = [];

  PackingChallanReport?.map((item) => {
    if (new Date(item?.PRMain_Date).getMonth() == 3) {
      AprPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 4) {
      MayPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 5) {
      JunePurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 6) {
      JulyPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 7) {
      AugPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 8) {
      SepPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 9) {
      OctPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 10) {
      NovPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 11) {
      DecPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 0) {
      JanPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 1) {
      FebPurchaseReturnReport.push(item);
    } else if (new Date(item?.PRMain_Date).getMonth() == 2) {
      MarchPurchaseReturnReport.push(item);
    }
  });

  const data3 = [
    {
      Month: "Apr",
      Purchase: AprPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: AprPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "May",
      Purchase: MayPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: MayPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "June",
      Purchase: JunePurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: JunePurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "July",
      Purchase: JulyPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: JulyPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Aug",
      Purchase: AugPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: AugPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Sep",
      Purchase: SepPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: SepPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Oct",
      Purchase: OctPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: OctPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Nov",
      Purchase: NovPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: NovPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Dec",
      Purchase: DecPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: DecPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Jan",
      Purchase: JanPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: JanPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Feb",
      Purchase: FebPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: FebPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
    {
      Month: "Mar",
      Purchase: MarchPurchaseBillReport?.reduce(
        (acc, item) => acc + item.P_Detail_Qty,
        0
      ),
      PurchaseReturn: MarchPurchaseReturnReport?.reduce(
        (acc, item) => acc + item.PRDtl_Qty,
        0
      ),
    },
  ];

  const uniqueParties = (array, key) => {
    const seen = new Set();
    return array?.filter((item) => {
      const value = item[key];
      if (!seen.has(value)) {
        seen.add(value);
        return true; // Keep this item
      }
      return false; // Skip duplicates
    });
  };

  const cardsData = [
    {
      link: "/PackingChallanReport",
      icon: <FaFileInvoice fontSize={40} />,
      bgcolor: "rgb(250, 90, 125)",
      bgcolorblur: "rgb(247, 230, 235)",
      name: "Packing Challan",
      customers: uniqueParties(PackingChallanReport, "SLBMain_AccountId")
        ?.length,
      orders: PackingChallanReport?.reduce((acc, item) => {
        if (!acc?.includes(item?.bill_no)) {
          acc.push(item?.bill_no)
        }
        return acc
      }, [])?.length,
      qty: PackingChallanReport?.reduce((acc, item) => acc + Number(item.design_qty), 0),
    },
    {
      link: "/StockReport",
      icon: <MdInventory fontSize={40} />,
      bgcolor: "rgb(13, 123, 219)",
      bgcolorblur: "rgb(216, 227, 240)",
      name: "Stock",
      qty: StockReport?.reduce(
        (acc, item) => acc + Number(item.bal_qty),
        0
      ),
    },
    {
      link: "/SaleReport",
      icon: <IoFileTrayStackedSharp fontSize={40} />,
      bgcolor: "rgb(208, 214, 34)",
      bgcolorblur: "rgb(246, 247, 220)",
      name: "Sale Report",
      qty: SaleReport?.reduce(
        (acc, item) => acc + Number(item.qty),
        0
      ),
    },
  ];


  useEffect(() => {
    dispatch(fetchDataStockRep({ cmpdetail: cmpdetail, UserDetail: UserDetail }));
    dispatch(fetchDataPKRep({ cmpdetail: cmpdetail, UserDetail: UserDetail }));
    dispatch(fetchDataSLRep({ cmpdetail: cmpdetail, UserDetail: UserDetail, FromDate: "", ToDate: "" }));
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h4: {
        fontWeight: "600",
        fontSize: "25px",
        "@media (max-width: 768px)": {
          fontSize: "20px",
        },
      },
      h5: {
        fontWeight: "500",
        fontSize: "20px",
        color: "#111",
        margin: "5px 10px",
        alignSelf: "center",
        justifySelf: "center",
        "@media (max-width: 768px)": {
          fontSize: "16px",
        },
      },
      h6: {
        fontSize: "15px",
        textAlign: "start",
        margin: "5px"
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "13px",
            maxWidth: "260px",
            height: "30px",
            padding: "12px 8px 12px 8px",
            fontWeight: 500,
            "@media (max-width: 768px)": {
              fontSize: "11px",
              padding: "10px 5px 10px 5px",
            },
          },
        },
      },
      MuiAvatar: {
        styleOverrides: {
          root: {
            width: 56,
            height: 56,
            alignSelf: "center",
            justifySelf: "center",
            padding: "10px",
            "@media (max-width: 768px)": {
              width: 46,
              height: 46,
            },
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: "#9a9da1",
          },
        },
      },
    },
  });

  return (
    <>
      <div className="main-box">
        <ThemeProvider theme={theme}>
          <div
            className="box-head d-flex justify-content-between align-items-center gap-1"
            style={{ margin: "10px 5px 10px 5px" }}
          >
            <Typography variant="h4">
              DashBoard
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              {/* <Collapse orientation="horizontal" in={openQuickLink}>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 2 }}
                  sx={{
                    "@media (max-width: 1200px)": {
                      display: "none"
                    },
                  }}
                >
                  {QuickLinkList?.map((item) => {
                    return <Item border={item?.border} bghover={item?.bghover} onClick={() => navigate(item?.link)}>{item?.name}</Item>
                  })}
                </Stack>
              </Collapse>
              <Button name="quick" variant="contained" startIcon={openQuickLink ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />} onClick={handleClick}>
                Quick Links
              </Button> */}
              {/* <Button name="date" variant="contained" onClick={handleClick}>
                {DateValue == dayjs(new Date()).format("YYYY-MM-DD")
                  ? "Today"
                  : dayjs(DateValue).format("ll")}
              </Button> */}
            </Box>
            {/* <Popover
              id={"simple-popover"}
              open={openQuickLink}
              anchorEl={anchorEl?.quick}
              onClose={() => handleClose("quick")}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "@media (min-width: 1200px)": {
                  display: "none"
                },
              }}
            >
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1, sm: 2, md: 4 }}
                sx={{
                  m: 2,
                  minWidth: "200px",
                  "@media (min-width: 1200px)": {
                    display: "none"
                  },
                }}
              >
                {QuickLinkList?.map((item) => {
                  return <Item border={item?.border} bghover={item?.bghover} onClick={() => navigate(item?.link)}>{item?.name}</Item>
                })}
              </Stack>
            </Popover> */}
            <Popover
              id={"simple-popover"}
              open={openCalender}
              anchorEl={anchorEl?.date}
              onClose={() => handleClose("date")}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  disableFuture
                  // maxDate={dayjs(cmpdetail?.ExpiryDate)}
                  views={["year", "month", "day"]}
                  value={dayjs(DateValue)}
                  onChange={(newValue) =>
                    setDateValue(newValue.format("YYYY-MM-DD"))
                  }
                  sx={{ bgcolor: "#f2f8fa" }}
                />
              </LocalizationProvider>
            </Popover>
          </div>
          <div
            className="d-flex flex-column align-items-center"
            style={{
              height: "88vh",
              padding: "20px 10px 20px 10px",
              overflowY: "scroll",
              backgroundColor: "#fff",
              borderRadius: "10px",
              transition: "ease 1s"
            }}
          >
            <Grid
              container
              spacing={3}
              columns={12}
              sx={{ width: "100%", display: "flex", flexDirection: "row" }}
            >
              {cardsData?.map((item, index) => {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                    key={index}
                  >
                    <Card
                      onClick={() => navigate(item?.link)}
                      sx={{
                        cursor: "pointer",
                        p: 1,
                        width: "100%",
                        background: item?.bgcolorblur,
                        color: "#151D48",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          m: 1,
                          gap: 2,
                        }}
                      >
                        <Avatar sx={{ bgcolor: item?.bgcolor }}>
                          {item?.icon}
                        </Avatar>
                        <Typography variant="h5">
                          {item?.name}
                        </Typography>
                      </Box>
                      <Divider sx={{ width: "100%" }} />
                      {item?.name == "Stock" || item?.name == "Sale Report" ? (
                        <></>
                      ) : (
                        <>
                          {/* <Typography variant="h6">
                            <FaUser
                              style={{
                                color: item?.bgcolor,
                                marginRight: "5px",
                              }}
                            />{" "}
                            No. of Party : {item?.customers}
                          </Typography> */}
                          <Typography variant="h6">
                            <FaBoxOpen
                              style={{
                                color: item?.bgcolor,
                                marginRight: "5px",
                              }}
                            />{" "}
                            No. Of Bill : {item?.orders}
                          </Typography>
                        </>
                      )}
                      <Typography variant="h6">
                        <RiNumbersFill
                          style={{ color: item?.bgcolor, marginRight: "5px" }}
                        />{" "}
                        QTY : {item?.qty}
                      </Typography>
                      {/* <Typography variant="h6">
                        <MdStraighten
                          style={{ color: item?.bgcolor, marginRight: "5px" }}
                        />{" "}
                        MTRs : {item?.mtrs}
                      </Typography> */}
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </ThemeProvider>
      </div>

      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
